export default __webpack_public_path__ + "images/logo-trachte.svg?1428c6d6e81512cd364ecc5826a9d844";